<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <el-alert
      type="warning"
      :closable="false"
      show-icon
      title="小程序成交发货后，同步微信成功或失败都会记入本列表。待处理可改填快递编码后手动补同步，系统也会每 2 分钟自动重试。闲鱼成交不会出现。仅记录本功能上线之后的同步。"
      style="margin-bottom: 12px"
    />

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
          <el-input v-model="query.orderNo" clearable placeholder="模糊" style="width: 180px" @keyup.enter.native="searchFn" />
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">订单ID：</span>
          <el-input v-model="query.orderIdStr" clearable placeholder="精确" style="width: 120px" @keyup.enter.native="searchFn" />
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">场景：</span>
          <el-select v-model="query.scene" clearable placeholder="全部" style="width: 180px">
            <el-option label="普通快递" value="EXPRESS" />
            <el-option label="自提" value="SELF_PICKUP" />
            <el-option label="安心购寄鉴别中心" value="INSPECTION_SELLER_TO_CENTER" />
            <el-option label="鉴别中心发买家" value="INSPECTION_CENTER_TO_BUYER" />
            <el-option label="安心购分拆收口" value="INSPECTION_SPLIT_FINISH_WITHOUT_BUYER" />
          </el-select>
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">状态：</span>
          <el-select v-model="query.status" style="width: 120px">
            <el-option label="全部" :value="-1" />
            <el-option label="待处理" :value="0" />
            <el-option label="已同步" :value="1" />
            <el-option label="已忽略" :value="2" />
          </el-select>
        </div>
        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <div class="table-scroll-wrap">
      <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
        <el-table-column prop="orderNo" label="订单号" min-width="170" show-overflow-tooltip />
        <el-table-column prop="orderId" label="订单ID" width="88" align="center" />
        <el-table-column prop="productTitle" label="商品" min-width="160" show-overflow-tooltip />
        <el-table-column prop="sceneLabel" label="场景" width="140" align="center" />
        <el-table-column label="物流公司" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.currentLogisticsCompany || scope.row.logisticsCompany || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="物流单号" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.currentLogisticsNo || scope.row.logisticsNo || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="failReason" label="同步结果" min-width="220" show-overflow-tooltip />
        <el-table-column prop="failCount" label="失败次数" width="88" align="center" />
        <el-table-column prop="retryCount" label="重试次数" width="88" align="center" />
        <el-table-column label="最近时间" width="168" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.resolvedAt || scope.row.lastFailAt || scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column prop="statusLabel" label="状态" width="88" align="center" />
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 0"
              type="text"
              size="small"
              @click="openRetry(scope.row)"
            >手动同步</el-button>
            <el-button
              v-if="scope.row.status === 0"
              type="text"
              size="small"
              @click="markIgnore(scope.row)"
            >忽略</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />

    <el-dialog title="手动同步到微信" :visible.sync="retryVisible" width="560px">
      <div v-if="retryRow" class="detail-box">
        <p><b>订单号：</b>{{ retryRow.orderNo }}</p>
        <p><b>场景：</b>{{ retryRow.sceneLabel }}</p>
        <p><b>失败原因：</b>{{ retryRow.failReason || "-" }}</p>
        <p><b>当前物流公司：</b>{{ retryRow.currentLogisticsCompany || retryRow.logisticsCompany || "-" }}</p>
        <p><b>当前物流单号：</b>{{ retryRow.currentLogisticsNo || retryRow.logisticsNo || "-" }}</p>
        <p style="margin-top: 12px">
          快递公司编码（可选）。映射失败时填写快递100编码如 <code>shunfeng</code>，或微信运力码如 <code>SF</code>。
        </p>
        <el-input v-model="retryCompany" placeholder="不填则用订单上现有物流公司" clearable />
      </div>
      <span slot="footer">
        <el-button @click="retryVisible = false">取消</el-button>
        <el-button type="primary" :loading="retryLoading" @click="submitRetry">同步到微信</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  name: "WxMaShipSyncFailList",
  data() {
    return {
      historyArr: ["客诉处理", "微信发货同步列表"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
      query: {
        orderNo: "",
        orderIdStr: "",
        scene: "",
        status: -1
      },
      retryVisible: false,
      retryLoading: false,
      retryRow: null,
      retryCompany: ""
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    buildPayload() {
      const payload = {
        page: this.currentPage,
        size: this.pageSize,
        status: this.query.status,
        orderNo: this.query.orderNo || undefined,
        scene: this.query.scene || undefined
      };
      if (this.query.orderIdStr) {
        payload.orderId = Number(this.query.orderIdStr);
      }
      return payload;
    },
    fetchList(page) {
      if (page) this.currentPage = page;
      this.loading = true;
      this.$https(this.$api.api.mgmtWxMaShipSyncFailList, this.buildPayload(), "POST")
        .then((res) => {
          const body = (res && res.data) || {};
          if (body.code === 200) {
            this.tableData = body.data || [];
            this.tableTotal = body.size != null ? body.size : 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error(body.msg || "查询失败");
          }
        })
        .catch(() => {
          this.tableData = [];
          this.tableTotal = 0;
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchFn() {
      this.fetchList(1);
    },
    resetFn() {
      this.query = { orderNo: "", orderIdStr: "", scene: "", status: -1 };
      this.fetchList(1);
    },
    changePage(p) {
      this.fetchList(p);
    },
    handlePageSizeChange() {
      this.fetchList(1);
    },
    openRetry(row) {
      this.retryRow = row;
      this.retryCompany = "";
      this.retryVisible = true;
    },
    submitRetry() {
      if (!this.retryRow || !this.retryRow.id) return;
      this.retryLoading = true;
      this.$https(
        this.$api.api.mgmtWxMaShipSyncFailRetry,
        {
          id: this.retryRow.id,
          expressCompanyOverride: (this.retryCompany || "").trim() || undefined
        },
        "POST"
      )
        .then((res) => {
          const body = (res && res.data) || {};
          if (body.code === 200) {
            this.$message.success(body.msg || "已同步到微信");
            this.retryVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error(body.msg || "同步失败");
          }
        })
        .catch(() => {
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.retryLoading = false;
        });
    },
    markIgnore(row) {
      if (!row || !row.id) return;
      this.$prompt("忽略备注（可选）", "标记忽略", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "如：已在微信后台补录"
      })
        .then(({ value }) => {
          return this.$https(
            this.$api.api.mgmtWxMaShipSyncFailIgnore,
            { id: row.id, manualNote: value || "" },
            "POST"
          );
        })
        .then((res) => {
          if (!res) return;
          const body = res.data || {};
          if (body.code === 200) {
            this.$message.success("已忽略");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error(body.msg || "操作失败");
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.detail-box p {
  margin: 8px 0;
  line-height: 1.6;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxMaShipSyncFail/index.vue